import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Icon } from 'src/common/components/templateDetails/TemplateDetails.styled';
import Grid from '@material-ui/core/Grid';

export const HeaderTextContainer1 = styled(Grid)`
    font-size: 18px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    color: #130e4a;
    opacity: 1;
`;

export const HeaderTextContainer2 = styled(Grid)`
    text-align: left;
    padding-top: 10px;
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    color: #202124;
`;

export const UserName = styled.div`
    color: #140f4b;
    font-size: 16px;
    font-family: 'AvenirNextWorld Demi';
`;

export const DesignationText = styled.div`
    font-size: 14px;
    color: #202124;
    opacity: 0.7;
    margin-left: 16px;
    margin-top: 3px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
    margin-left: 0px;
    margin-top: 0px;
    `}
`;

export const HeaderTextContainer3 = styled(Grid)`
    font-size: 14px;
    margin-left: 25px;
    padding-bottom: 10px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    opacity: 1;
`;

export const Container1 = styled(Grid)``;

export const ContainerGrid1 = styled(Grid)``;

export const Line = styled(Grid)`
    margin-top: 45px;
    width: 100%;
    border: 1px solid #707070;
    background-color: #707070;
    opacity: 0.2;
    ${media.mobileDevice`
    margin-top: 25px;
    `}
`;

export const CloseIcon = styled(Icon)`
    margin: 0 0 0 auto;
    ${media.smalDevice`
    margin-left: ${(props) => props.ipadMarginLeft};
    `}
`;

export const UserContainer = styled(Grid)`
    margin-top: 20px;
`;

export const UserContainer1 = styled(Grid)`
    display: flex;
    flex-direction: row;
    align-items: center;
    ${media.smalDevice`  
    flex-direction: row; 
    margin-left: 0px ;  
    align-items: flex-start;
    `}
    ${media.mobileDevice` 
    align-items: flex-start; 
    flex-direction: column; 
    margin-left: 0px ;    
    `}
`;

export const BottomNavigationButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    right: 0;
    background-color: white;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};

    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        justify-content: ${({ smallJustifyContent }) =>
            smallJustifyContent ? smallJustifyContent : 'flex-end'};
        padding-right: 0px;
        padding: ${(props) => (props.mbPadding ? props.mbPadding : '0px')};
    }
    ${media.smalDevice`    
        background-color: #FFFFFF;
          padding: ${(props) =>
              props.ipadPadding ? props.ipadPadding : '0px'};`}
    ${media.mobileDevice` 
        
         background-color: #FFFFFF;
           padding: ${(props) => (props.mbPadding ? props.mbPadding : '0px')};`}
    @media screen and (orientation: landscape) and (max-height: 576px) and (pointer: coarse) {
        max-height: ${({viewportHeight}) => viewportHeight ? `${viewportHeight}px` : '100vh'};
        overflow-y: auto;
    }
`;
export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld demi;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
`;
